import React from 'react';
import { Box, Typography } from '@mui/material';
import { getRelativeDateString } from '../utils/FirestoreUtils';

interface DateDividerProps {
  date: Date;
}

const DateDivider: React.FC<DateDividerProps> = ({ date }) => {
  const dateText = getRelativeDateString(date);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        my: 2.5,
      }}
    >
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{
          px: 1.5,
          py: 0.4,
          fontSize: '0.72rem',
          fontWeight: 600,
          letterSpacing: '0.04em',
          borderRadius: 999,
          border: '1px solid',
          borderColor: 'divider',
          backgroundColor: 'background.paper',
        }}
      >
        {dateText}
      </Typography>
    </Box>
  );
};

export default DateDivider;